<template>
    <span>
        <ImportCSV enabled name="importCV" @fileUploaded="formatData"
                   @fileUploadedError="fileError()"/>
    </span>
</template>

<script>
import ImportCSV from 'components/importCSV/ImportCSV.vue';
import VALIDATIONS from 'pages/conversionValue/cvManager/components/validations';
import { formatCVMapResponse } from 'pages/conversionValue/cvManager/serviceUtils';
import { isSorted } from 'services/utils/arrayUtils';
import mapKeys from 'lodash/mapKeys';
import * as consts from './consts';

export default {
    name: 'ImportCV',
    components: { ImportCSV },
    data() {
        return {
            data: null,
            steps: null,
            fields: null,
            validationError: null,
            ...consts
        };
    },
    methods: {
        formatData(rawData) {
            try {
                this.steps = rawData.data;
                this.fields = rawData.fields;
                this.validateFields();
                this.formatLastStep();
                this.validateInRange();
                this.validateAdRevenue();
                this.validateSortedCV();
                this.validateSortedAdRevenue();
                this.$emit('importSteps', this.formattedSteps);
            } catch (error) {
                this.showValidationErrorModal(error);
            }
        },
        validateFields() {
            this.fields = this.fields.map((field) => field.toLowerCase());
            this.steps = this.steps.map((step) => mapKeys(step, (value, key) => key.toLowerCase()));

            if (!this.fields.includes('cv') || !this.fields.includes('ad_revenue')) {
                throw VALIDATIONS.mandatoryFields;
            }
        },
        validateInRange() {
            if (this.steps.some((row) => (
                !Number.isInteger(row.cv) || row.cv < this.minSteps || row.cv >= this.maxSteps
            ))) {
                throw VALIDATIONS.inRange;
            }
        },
        validateAdRevenue() {
            this.steps.some((row) => {
                // Number.isNaN doesn't catch all cases.
                // eslint-disable-next-line no-restricted-globals
                if (isNaN(row.ad_revenue)) {
                    throw VALIDATIONS.adRevenueValues;
                }
                if (!Number.isInteger(Number((row.ad_revenue / this.adRevenueDivider).toFixed(5)))) {
                    throw VALIDATIONS.adRevenue;
                }
                return false;
            });
        },
        validateSortedCV() {
            if (!isSorted(this.steps, 'cv', true, 0)) {
                throw VALIDATIONS.sortedCV;
            }
        },
        validateSortedAdRevenue() {
            const data = this.steps.slice();
            if (!isSorted(data, 'ad_revenue', false)) {
                throw VALIDATIONS.sortedAdRevenue;
            }
        },
        formatLastStep() {
            const allowedLastStepValues = ['infinity', 'Infinity', null];
            const lastStepAdRevenueValid = !this.lastStep || !this.lastStep.ad_revenue
                || allowedLastStepValues.includes(this.lastStep.ad_revenue);
            const lastStepValid = this.lastStep && lastStepAdRevenueValid && this.steps.length < this.maxSteps;
            const fixLastStep = this.steps.length === this.maxSteps && !allowedLastStepValues.includes(this.lastStep);
            if (lastStepValid || fixLastStep) {
                this.steps.pop();
            }

            if (!this.steps.length || !this.lastStep || !this.lastStep.ad_revenue) {
                this.steps.push({ cv: 0, ad_revenue: 0 });
            }
        },
        showValidationErrorModal(error) {
            this.$modal.open({
                title: 'CSV Import Failed',
                body: error,
                version: 1,
                type: 'error',
                clickOutsideClose: true,
                showCancelButton: false
            });
        },
        fileError() {
            this.showValidationErrorModal(VALIDATIONS.invalidFormat);
        }
    },
    computed: {
        lastStep() {
            return this.steps[this.steps.length - 1];
        },
        formattedSteps() {
            const steps = this.steps.map((step) => ({
                key: step.cv,
                max: Number((step.ad_revenue * 100).toFixed(5))
            }));
            return formatCVMapResponse(steps);
        }
    }
};
</script>

<style scoped lang="scss">
@import "~styles/styleGuide.scss";

.modal-mask {
    position: fixed;
}
</style>
